module.exports = __webpack_public_path__ + "static/img/glove_ocre.91be02c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_ocre.png
// module id = 1gbl
// module chunks = 0